export default __webpack_public_path__ + "images/49c8fd2de5a9ed70f1ea65e0e92a994c-track.png";